import React from 'react';
import { useTranslation } from 'react-i18next';
import './TermsPage.css';

const TermsPage: React.FC = () => {
  const { t } = useTranslation('legal');

  return (
    <div className="terms-page">
      <div className="terms-header">
        <h1>{t('terms.title')}</h1>
        <p>{t('terms.subtitle')}</p>

        <div className="wave-divider">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
          </svg>
        </div>
      </div>

      <section>
        <div className="terms-content bg-white p-5 rounded shadow">
          <h2>{t('terms.section1_title')}</h2>
          <p>{t('terms.section1_text1')}</p>
          <p>{t('terms.section1_text2')}</p>

          <h2>{t('terms.section2_title')}</h2>
          <p>{t('terms.section2_text')}</p>

          <h2>{t('terms.section3_title')}</h2>
          <h3>{t('terms.section3_executor_duties_title')}</h3>
          <ul>
            {(t('terms.section3_executor_duties', { returnObjects: true }) as string[]).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h3>{t('terms.section3_customer_duties_title')}</h3>
          <ul>
            {(t('terms.section3_customer_duties', { returnObjects: true }) as string[]).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h3>{t('terms.section3_executor_rights_title')}</h3>
          <ul>
            {(t('terms.section3_executor_rights', { returnObjects: true }) as string[]).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h2>{t('terms.section4_title')}</h2>
          <p>{t('terms.section4_text')}</p>
          <ul>
            {(t('terms.section4_items', { returnObjects: true }) as string[]).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h2>{t('terms.section5_title')}</h2>
          <p>{t('terms.section5_text')}</p>
          <ul>
            {(t('terms.section5_items', { returnObjects: true }) as string[]).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <p>{t('terms.section5_footer')}</p>

          <h2>{t('terms.section6_title')}</h2>
          <p>{t('terms.section6_text')}</p>
          <ul>
            {(t('terms.section6_items', { returnObjects: true }) as string[]).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h2>{t('terms.section7_title')}</h2>
          <p>{t('terms.section7_text')}</p>

          <h2>{t('terms.section8_title')}</h2>
          <p>{t('terms.section8_text1')}</p>
          <p>{t('terms.section8_text2')}</p>
          <ul>
            {(t('terms.section8_items', { returnObjects: true }) as string[]).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h2>{t('terms.section9_title')}</h2>
          <p>{t('terms.section9_text')}</p>

          <h2>{t('terms.section10_title')}</h2>
          <ul>
            {(t('terms.section10_items', { returnObjects: true }) as string[]).map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>

          <h2>{t('terms.section11_title')}</h2>
          <p>{t('terms.section11_text')}</p>

          <div className="terms-footer">
            <p>{t('terms.last_updated')}</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsPage;
